<template>
  <div class="tab-control" ref="box">
      <div class="ul"
           v-for="(item,index) in titles"
           :ref="`item+${index}`">
        <div @click="itemClick(index)"
             class="item"
             :class="{active_no_sel: index != currentIndex,
                      active_sel: index==currentIndex}"><span>{{item}}</span></div>
      </div>
  </div>
</template>
<script>
export default {
  name: "lvTabCtrl",
  data(){
    return{
      currentIndex: 0,
      offsetX: 0,
      // titles: [ '详情介绍'] //'图文直播', '聊天',
      titles: [ '图文直播', '聊天', '详情介绍'] //
    }
  },
  mounted() {
  },
  methods:{
    itemClick(index){
      // console.log("cur="+index)
      if(this.currentIndex == index)
        return;

      this.currentIndex = index
      this.$emit('vlTabClick', index)
    },
    setIndex(id){
      this.currentIndex = id
    },
  }
}
</script>

<style scoped>

@keyframes scale {
  0% {
    /*transform: scale(1);*/
    transform: perspective(15px)scale(1) rotateX(1deg);
  }
  50% {
    /*transform: scale(1.13, 1.13);*/
    transform: perspective(15px)scale(1.08, 1.08) rotateX(1deg);
  }
  100% {
    /*transform: scale(1.065, 1.065);*/
    transform: perspective(15px)scale(1.04, 1.04) rotateX(1deg);
  }
}

@-webkit-keyframes scale {
  0% {
    /*transform: scale(1);*/
    transform: perspective(15px)scale(1) rotateX(1deg);
  }
  50% {
    /*transform: scale(1.13, 1.13);*/
    transform: perspective(15px)scale(1.13, 1.13) rotateX(1deg);
  }
  100% {
    /*transform: scale(1.065, 1.065);*/
    transform: perspective(15px)scale(1.065, 1.065) rotateX(1deg);
  }
}

.tab-control{
  position: relative;
  display: flex;
  flex-direction: row;

  margin: auto;

  text-align: center;
  height: 150px;
  width: 100%;
  line-height: 150px;
  color: whitesmoke;
  overflow: hidden;

  flex-wrap:nowrap;
  font-size: 45px;


}
.tab-control::-webkit-scrollbar {
  display: none;
}

.ul{
  flex: 1;
}
.item{
  border-left: #c5c5c5 1px solid;
}
.active_sel{
  font-size: 50px;
  background-color: #009bff;
  font-weight: bolder;
}
.active_no_sel{
  background-color: #0089e1;
}


</style>
